<template>
  <div
    class="quote-msg-container"
    :class="{
      'unsended-quote-container': !sended,
      'space-bottom-sm space-top-0': sended,
      'is-image': isImage
    }"
  >
    <span class="msg-quote-box" @click="scrollToReference">
      <div
        class="msg-quote-info"
        :class="{
          'width-with-preview': attachment && (isImage || isVideo || !isAudio)
        }"
        :style="borderStyle"
      >
        <span
          class="msg-quote-user"
          :style="`color: rgba(${settingsBgColorRGBA});`"
        >
          {{ quote.user.displayName || quote.user.name }}
        </span>

        <span
          v-if="quote.comment"
          class="msg-quote-comment"
          :style="`color: rgba(${settingsBgColorRGBA});`"
        >
          {{ quote.comment }}
        </span>

        <span v-if="isImage" class="msg-quote-comment">
          <svg
            style="
              width: 14px;
              height: 14px;
              fill: #666;
              display: inline-block;
              vertical-align: middle;
            "
            viewBox="0 0 24 24"
          >
            <path
              d="M4,4H7L9,2H15L17,4H20A2,2 0 0,1 22,6V18A2,2 0 0,1 20,20H4A2,2 0 0,1 2,18V6A2,2 0 0,1 4,4M12,7A5,5 0 0,0 7,12A5,5 0 0,0 12,17A5,5 0 0,0 17,12A5,5 0 0,0 12,7M12,9A3,3 0 0,1 15,12A3,3 0 0,1 12,15A3,3 0 0,1 9,12A3,3 0 0,1 12,9Z"
            />
          </svg>
          <span>{{ $t('conversation.quote.image') }}</span>
        </span>

        <span v-else-if="isAudio">
          <svg
            style="
              width: 14px;
              height: 14px;
              fill: #666;
              display: inline-block;
              vertical-align: middle;
            "
            viewBox="0 0 24 24"
          >
            <path
              d="M12,2A3,3 0 0,1 15,5V11A3,3 0 0,1 12,14A3,3 0 0,1 9,11V5A3,3 0 0,1 12,2M19,11C19,14.53 16.39,17.44 13,17.93V21H11V17.93C7.61,17.44 5,14.53 5,11H7A5,5 0 0,0 12,16A5,5 0 0,0 17,11H19Z"
            />
          </svg>

          <span>{{ $t('conversation.quote.audio') }}</span>
        </span>

        <span v-else-if="isVideo">
          <svg
            style="
              width: 14px;
              height: 14px;
              fill: #666;
              display: inline-block;
              vertical-align: middle;
            "
            viewBox="0 0 24 24"
          >
            <path
              d="M17,10.5V7A1,1 0 0,0 16,6H4A1,1 0 0,0 3,7V17A1,1 0 0,0 4,18H16A1,1 0 0,0 17,17V13.5L21,17.5V6.5L17,10.5Z"
            />
          </svg>

          <span>{{ $t('conversation.quote.video') }}</span>
        </span>

        <span v-else-if="attachment && !isAudio">
          <svg
            style="
              width: 14px;
              height: 14px;
              fill: #666;
              display: inline-block;
              vertical-align: middle;
            "
            viewBox="0 0 24 24"
          >
            <path
              d="M14,17H7V15H14M17,13H7V11H17M17,9H7V7H17M19,3H5C3.89,3 3,3.89 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19V5C21,3.89 20.1,3 19,3Z"
            />
          </svg>
          <span class="msg-quote-comment">{{ attachment.name }}</span>
        </span>
      </div>

      <div
        v-if="attachment && (isImage || isVideo || !isAudio)"
        class="msg-quote-preview"
        :style="`background-color: rgba(${settings.bgColorRGBA}`"
      >
        <ConversationMessageAttachment
          width="80px"
          height="57px"
          :attachment="quote.attachments[0]"
          :is-quote="true"
        />
      </div>
    </span>

    <btn
      v-if="!sended"
      class="btn-sem-style icon-close space-right-sm quote--close--btn"
      @click="cancelQuote"
    />
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import { isClient } from '@/helpers'

  import ConversationMessageAttachment from './events/message/ConversationMessageAttachment'

  export default {
    components: {
      ConversationMessageAttachment
    },
    props: {
      quote: {
        type: Object,
        required: true
      },
      sended: {
        type: Boolean,
        required: false
      }
    },
    computed: {
      ...mapGetters(['settings']),
      borderStyle() {
        let newRBGAColor = this.settings.bgColorRGBA.split(',')

        newRBGAColor.pop()

        newRBGAColor.push(' 1')

        return `border-left: 2px solid rgba(${newRBGAColor});`
      },
      settingsBgColorRGBA() {
        return this.settings.bgColorRGBA
      },
      isClientMessage() {
        return isClient(this.quote.user.type)
      },
      attachment() {
        return this.quote.attachments && this.quote.attachments.length > 0
          ? this.quote.attachments[0]
          : undefined
      },
      isImage() {
        return (
          this.attachment &&
          this.parseExtension(this.attachment.url.toLowerCase()).match(
            /(jpg|jpeg|png|gif|web|svg)$/
          )
        )
      },
      isAudio() {
        return (
          this.attachment &&
          this.parseExtension(this.attachment.url.toLowerCase()).match(
            /(mp3|ogg|wav|opus)$/
          )
        )
      },
      isVideo() {
        return (
          this.attachment &&
          this.parseExtension(this.attachment.url.toLowerCase()).match(
            /(mp4|webM)$/
          )
        )
      }
    },
    methods: {
      ...mapActions(['cancelQuote', 'focusMessage', 'clearFocusMessage']),
      parseExtension(url) {
        return url.split('.')[url.split('.').length - 1]
      },
      scrollToReference() {
        this.$nextTick(() => {
          if (typeof document !== 'undefined') {
            const containerRef = document.getElementById(this.quote.key)

            if (containerRef) {
              containerRef.scrollIntoView()

              this.focusMessage(this.quote.key).then(() =>
                setTimeout(this.clearFocusMessage, 1500)
              )
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .unsended-quote-container {
    overflow: hidden;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.15);
    margin-top: -10px;
  }

  .width-with-preview {
    width: calc(100% - 80px) !important;
  }

  @media screen and (max-width: 767px) {
    .unsended-quote-container {
      .btn {
        width: auto !important;
      }
    }
  }

  .quote-msg-container {
    &.conversation-on-footer {
      position: absolute;
      top: -70px;
      left: -5px;
    }
    margin: 0px;
    text-align: left;
    height: 57px;
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    &.is-image {
      .msg-quote-info {
        max-width: 75%;
        width: 75%;
      }
    }
    &:not(.unsended-quote-container) {
      height: auto;
      white-space: normal;
      span.msg-quote-box {
        height: auto;
        padding: 10px 0px;
        span.msg-quote-comment {
          max-height: 45px;
          white-space: normal;
          font-size: 12px;
          line-height: 15px;
        }
      }
    }
    .msg-quote-box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      width: 100%;
      height: 57px;
      padding: 0;
      border-radius: 8px;
      word-break: break-word;
      background: #eee;
      color: #666 !important;
      cursor: pointer;
      .msg-quote-info {
        width: 90%;
        padding: 7px 10px 5px 10px;
        display: flex;
        flex-direction: column;
        .msg-quote-user {
          overflow: hidden;
          max-width: 100%;
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 0.625rem;
          margin-bottom: 4px;
        }

        .msg-quote-comment {
          vertical-align: middle;
          line-height: 15px;
          overflow: hidden;
          max-width: 100%;
          display: inline-block;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }

      .msg-quote-preview {
        width: 80px;
        height: 57px;
        text-align: center;
      }
    }
  }

  .msg-quote-info {
    margin-left: 8px;
  }

  .quote--close--btn {
    position: absolute;
    right: 0;
  }
</style>
